import { a2aTransfersSagas } from 'app-components/flux/a2aTransfers';
import { accountDiscoverySagas } from 'app-components/flux/account-discovery';
import { accountsDumpUpdater, accountsNudgeUpdater, accountsSagas } from 'app-components/flux/accounts';
import { accountsBalancesSagas } from 'app-components/flux/accounts-balances';
import { accountsBalancesHistorySagas } from 'app-components/flux/accounts-balances-history';
import { accountsValueChangesSagas } from 'app-components/flux/accounts-value-changes';
import { achievementsSagas } from 'app-components/flux/achievements';
import { alertRulesSagas } from 'app-components/flux/alert-rules';
import { alertsSagas } from 'app-components/flux/alerts';
import {
  billableItemsDumpBump,
  billableItemsNudgeBump,
} from 'app-components/flux/billable-invoice-items/billableInvoiceItemsSlice';
import { bumpSagas, subscribeForBumpUpdates } from 'app-components/flux/bump';
import { businessDumpUpdater, businessNudgeUpdater, businessSagas } from 'app-components/flux/business';
import { categoriesDumpUpdater, categoriesNudgeUpdater, categoriesSagas } from 'app-components/flux/categories';
import creditProfileSagas from 'app-components/flux/credit-profile/sagas';
import creditReportSagas from 'app-components/flux/credit-report/sagas';
import { customersSagas } from 'app-components/flux/customers';
import { termsSagas } from 'app-components/flux/terms';
import { datasetsSagas } from 'app-components/flux/datasets';
import { dateSagas } from 'app-components/flux/date';
import { documentsSagas } from 'app-components/flux/documents';
import { entitlementsSagas } from 'app-components/flux/entitlements';
import { filtersDumpUpdater, filtersNudgeUpdater, filtersSagas } from 'app-components/flux/filters';
import { freeToSpendDumpUpdater, freeToSpendNudgeUpdater, freeToSpendSagas } from 'app-components/flux/free-to-spend';
import { generatedReportsSagas } from 'app-components/flux/generated-reports';
import { goalsDumpUpdater, goalsNudgeUpdater, goalsSagas } from 'app-components/flux/goals';
import { houseStatsSagas } from 'app-components/flux/house-stats';
import { housingSelectionSagas } from 'app-components/flux/housing-selection';
import {
  institutionLoginsDumpUpdater,
  institutionLoginsNudgeUpdater,
  institutionLoginsSagas,
} from 'app-components/flux/institution-logins';
import { institutionsSagas } from 'app-components/flux/institutions';
import { investmentHoldingsV2Sagas } from 'app-components/flux/investment-holdings-v2';
import { investmentIRRSagas } from 'app-components/flux/investment-irr';
import { investmentQuotesV2Sagas } from 'app-components/flux/investment-quotes-v2';
import { investmentSymbolsSagas } from 'app-components/flux/investment-symbols';
import { investmentTWRRSagas } from 'app-components/flux/investment-twrr';
import { investmentsNewsfeedSagas } from 'app-components/flux/investments-newsfeed';
import { invoiceItemsDumpBump, invoiceItemsNudgeBump } from 'app-components/flux/invoice-items/invoiceItemsSlice';
import { jobStatusSagas } from 'app-components/flux/job-status';
import { milestonesDumpUpdater, milestonesNudgeUpdater } from 'app-components/flux/milestones';
import { npsSagas } from 'app-components/flux/nps';
import { paymentMethodsSagas } from 'app-components/flux/payment-methods';
import { postponedActionsSagas } from 'app-components/flux/postponed-actions';
import {
  preferencesDumpUpdater,
  preferencesNudgeUpdater,
  preferencesV2Sagas,
} from 'app-components/flux/preferences-v2';
import { profileSagas } from 'app-components/flux/profile';
import { projectsSagas } from 'app-components/flux/projects';
import { reportConfigurationsSagas } from 'app-components/flux/report-configurations';
import { rootUiSagas } from 'app-components/flux/root-ui';
import {
  scheduledTransactionsDumpUpdater,
  scheduledTransactionsNudgeUpdater,
  scheduledTransactionsSagas,
} from 'app-components/flux/scheduled-transactions';
import { securitiesDumpUpdater, securitiesNudgeUpdater, securitiesSagas } from 'app-components/flux/securities';
import { sharesSagas } from 'app-components/flux/shares';
import { spendingWatchlistSagas } from 'app-components/flux/spending-watchlist';
import { ssoSagas } from 'app-components/flux/sso';
import { subscriptionsSagas } from 'app-components/flux/subscriptions';
import { tagsDumpUpdater, tagsNudgeUpdater, tagsSagas } from 'app-components/flux/tags';
import { taxFormsSagas } from 'app-components/flux/tax-forms';
import { taxLineItemsSagas } from 'app-components/flux/tax-line-items';
import taxesSagas from 'app-components/flux/taxes/taxesSagas';
import tickerLogosSagas from 'app-components/flux/ticker-logos/tickerLogosSagas';
import { transactionsDumpUpdater, transactionsNudgeUpdater, transactionsSagas } from 'app-components/flux/transactions';
import { userInfoSagas } from 'app-components/flux/user-info';
import { vehicleSagas } from 'app-components/flux/vehicle';
import { sagas as persistSagas } from 'app-components/utils/persist';

import bumpDevSagas from 'containers/App/DevMenu/bumpSagas';
import aiConversationsSagas from 'data/aiConversations/aiConversationsSagas';
import appSagas from 'data/app/sagas';
import creditProfileSagasPrivate from 'data/creditProfile/sagas';
import feedbackSagas from 'data/feedback/feedbackSagas';
import fundingAccountsSagas from 'data/fundingAccounts/sagas';
import importSagas, { pfmImportJobUpdater, pfmImportNudgeUpdater } from 'data/import/importSagas';
import pauthReauthSagas from 'data/institutionLogins/pauthReauthSagas';
import milestonesSagas from 'data/milestones/milestoneSagas';
import mixpanelSagas from 'data/mixpanel/mixpanelSagas';
import preferencesSagas from 'data/preferences/sagas';
import transactionsSagasPrivate from 'data/transactions/sagas';
import transferBalanceSagas from 'data/transferBalance/transferBalanceSagas';
import transferHistorySagas from 'data/transferHistory/transferHistorySagas';
import tripsSagas from 'data/trips/sagas';

import type { Saga } from 'redux-saga';
import { spawn } from 'redux-saga/effects';
import authSagas from 'utils/auth/authSagas'; // wraps app-components
import featureFlagsSagas from 'utils/featureFlags/featureFlagsSagas';
import {
  reportConfigurationsDumpUpdater,
  reportConfigurationsNudgeUpdater,
} from 'app-components/flux/report-configurations/reportConfigurationsSagas';

const sagas: { [key: string]: Array<Saga> } = {
  //  ADD THINGS IN ALPHABETICAL ORDER PLEASE
  a2aTransfersSagas,
  accountsSagas,
  accountDiscoverySagas,
  accountsBalancesSagas,
  accountsBalancesHistorySagas,
  accountsValueChangesSagas,
  achievementsSagas,
  aiConversationsSagas,
  alertRulesSagas,
  alertsSagas,
  appSagas,
  authSagas,
  bumpSagas,
  bumpDevSagas,
  businessSagas,
  categoriesSagas,
  creditProfileSagas,
  creditProfileSagasPrivate,
  creditReportSagas,
  customersSagas,
  dateSagas,
  datasetsSagas,
  documentsSagas,
  entitlementsSagas,
  featureFlagsSagas,
  feedbackSagas,
  filtersSagas,
  freeToSpendSagas,
  fundingAccountsSagas,
  generatedReportsSagas,
  goalsSagas,
  houseStatsSagas,
  housingSelectionSagas,
  importSagas,
  investmentIRRSagas,
  investmentTWRRSagas,
  investmentQuotesV2Sagas,
  investmentSymbolsSagas,
  investmentsNewsfeedSagas,
  institutionsSagas,
  institutionLoginsSagas,
  investmentHoldingsV2Sagas,
  jobStatusSagas,
  milestonesSagas,
  mixpanelSagas,
  npsSagas,
  pauthReauthSagas,
  paymentMethodsSagas,
  persistSagas,
  postponedActionsSagas,
  preferencesSagas,
  preferencesV2Sagas,
  profileSagas,
  projectsSagas,
  reportConfigurationsSagas,
  rootUiSagas,
  scheduledTransactionsSagas,
  securitiesSagas,
  sharesSagas,
  spendingWatchlistSagas,
  ssoSagas,
  subscriptionsSagas,
  tagsSagas,
  taxFormsSagas,
  taxLineItemsSagas,
  taxesSagas,
  tickerLogosSagas,
  transactionsSagasPrivate,
  termsSagas,
  transactionsSagas,
  transferHistorySagas,
  transferBalanceSagas,
  tripsSagas,
  userInfoSagas,
  vehicleSagas,
  //  ADD THINGS IN ALPHABETICAL ORDER PLEASE
};

export function* rootSaga() {
  for (const sagaGroup of Object.values(sagas)) {
    for (const saga of sagaGroup) {
      yield spawn(saga);
    }
  }
}

subscribeForBumpUpdates('accounts', accountsDumpUpdater, accountsNudgeUpdater);
subscribeForBumpUpdates('badges', milestonesDumpUpdater, milestonesNudgeUpdater);
subscribeForBumpUpdates('transactions', transactionsDumpUpdater, transactionsNudgeUpdater);
subscribeForBumpUpdates('free-to-spends', freeToSpendDumpUpdater, freeToSpendNudgeUpdater);
subscribeForBumpUpdates('goals', goalsDumpUpdater, goalsNudgeUpdater);
subscribeForBumpUpdates('PFM_IMPORT', undefined, pfmImportNudgeUpdater); // IS THIS USED??
subscribeForBumpUpdates('tags', tagsDumpUpdater, tagsNudgeUpdater);
subscribeForBumpUpdates('investment-security', securitiesDumpUpdater, securitiesNudgeUpdater);
subscribeForBumpUpdates('categories', categoriesDumpUpdater, categoriesNudgeUpdater);
subscribeForBumpUpdates('PFM_IMPORTER', undefined, undefined, pfmImportJobUpdater);
subscribeForBumpUpdates('filters', filtersDumpUpdater, filtersNudgeUpdater);
subscribeForBumpUpdates('billable-items', billableItemsDumpBump, billableItemsNudgeBump);
subscribeForBumpUpdates('item', invoiceItemsDumpBump, invoiceItemsNudgeBump);
subscribeForBumpUpdates('businesses', businessDumpUpdater, businessNudgeUpdater);
subscribeForBumpUpdates('preference-override', preferencesDumpUpdater, preferencesNudgeUpdater);
subscribeForBumpUpdates('institution-logins', institutionLoginsDumpUpdater, institutionLoginsNudgeUpdater);
subscribeForBumpUpdates('scheduledTransactions', scheduledTransactionsDumpUpdater, scheduledTransactionsNudgeUpdater);
subscribeForBumpUpdates('report-config', reportConfigurationsDumpUpdater, reportConfigurationsNudgeUpdater);
